/* eslint-disable react/sort-comp */

import React from 'react';
import Relay from 'react-relay/classic';
import findIndex from 'lodash/findIndex';
import isEqual from 'lodash/isEqual';
import difference from 'lodash/difference';
import PropTypes from 'prop-types';
import { Style } from 'radium';
import c from 'classnames';
import $j from 'jquery';
import Dotdotdot from 'react-dotdotdot';
import { withTheme } from 'emotion-theming';
import {
  SnackBarHelper,
  Icon as IconComponent,
  ActivityIndicator
} from '@lyearn-team/frontend-components';
import themeConfig from '@lyearn-team/theme-config';
import { observer, disposeOnUnmount } from 'mobx-react';
import { CourseCompletionOrderEnum, CardCompletionTypeEnum, LessonEventsFromEnum } from 'appConsts';
import { getQueryStringVal } from 'helper/QueryString';
import ViewBadge, { badgeExists, parseBadge } from 'learner/components/ViewBadge';
import { userContentStatus } from 'helper/userContentStatus';
import { RoomStatus } from 'components/LiveClass/utils/consts';
import {
  LiveClassConsumer,
  withLiveClassModel
} from 'components/LiveClass/components/LiveClassConsumer';
import withLiveClassElements from 'components/LiveClassElements';
import withPreRequisiteCheck from 'components/PreRequisiteCheck';

import { reaction } from 'mobx';
import LearnerCard from '../learnerCard';
import SectionCell from './SectionCell';
import Icon from '../../helper/Icon';
import OverlayLoader from '../../../components/OverlayLoader';
import User from '../../../helper/currentUser';
import windowResize from '../../../helper/WindowResize';
import { CollapsableItem, CollapsableGroup } from './Collapsable';
import CourseDetails from './CourseDetails';
import getFirstAvailableCardId from './utils/getFirstAvailableCardId';
import checkIfCardLocked from './utils/checkIfCardLocked';
import RelayQueryRendererLegacy from '../../../components/RelayQueryRendererLegacy';
import LearnerViewCardsRoute from '../../queries/LearnerViewCardsRoute';
import { cardProgressSyncStatus } from './utils/cardProgressSyncStatus';
import CourseCompleteSnackBar from './components/CourseCompleteSnackBar';
import ViewCertificate from '../../components/ViewCertificate';
import RemainingLessonsPopup, { getRemainingLessonsInfo } from './components/RemainingLessonsPopup';
import { refetchCourseAndUpdateRelayStore } from './utils/refetchAndSaveCourseData';
import rootQuery from './rootQuery';
import isComponentMounted from './isComponentMounted';
import * as s from './styles';
import LearnerAccentButton from './components/LearnerAccentButton';

const user = new User();

const addTimeSeconds = 20000.0;
const kBoldFont = 500.0;

const cardNotAccessibleCoursePids = ['5adf3d95fd4257000fe52444', '5addec89c59b4900157db90c'];

const getCardIdFromQS = () => getQueryStringVal('cardId', window.location.href);

@withPreRequisiteCheck
@withLiveClassElements
@withTheme
@withLiveClassModel
@observer
class LearnerViewCards extends React.Component {
  static contextTypes = {
    snackbar: PropTypes.func,
    closeSearch: PropTypes.func,
    router: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.cardInfoArray = [];
    this.cardArray = [];
    this.cardIdArray = [];
    this.currentCardIndex = null;
    this.isScormOnlyCourse = false;
    let initialCardId = '';

    const course = this.props.rootQ;

    if (!course) {
      const errorMessage = this.props.error ? this.props.error.message : '';
      if (errorMessage.includes('DELETED_COURSE_REDIRECT_TO_LEARNER_PAGE')) {
        SnackBarHelper.showSnackbar({
          label: 'Course is deleted',
          duration: 10,
          hideCancel: true,
          isAlert: true
        });
      } else if (errorMessage.includes('Authorization Exception')) {
        SnackBarHelper.showSnackbar({
          label: (
            <span>
              Error due System Date Misconfiguration.{' '}
              <a
                href="https://intercom.help/lyearn/en/articles/3557074-how-to-resolve-system-date-misconfiguration-error"
                rel="noopener noreferrer"
                target="_blank"
              >
                Please read this to resolve.
              </a>
            </span>
          ),
          duration: 10,
          hideCancel: true,
          isAlert: true
        });
      } else {
        SnackBarHelper.showSnackbar({
          label: 'Error fetching course. Please contact support',
          duration: 10,
          hideCancel: true,
          isAlert: true
        });
      }
      window.analytics &&
        window.analytics.track('ERROR_FETCHING_COURSE', {
          url: JSON.stringify(this.props.location),
          error: errorMessage
        });
      this.doNotRenderCourse = true;
      window.location.href = '/#/learner';
      return true;
    }

    const cardId =
      this.props.cardId ||
      (this.props.match && this.props.match.params.cardId) ||
      getCardIdFromQS();

    if (cardId) {
      initialCardId = cardId;
    } else {
      initialCardId = getFirstAvailableCardId(course);
    }
    this.state = {
      currentCardPid: initialCardId,
      currentCard: null,
      showSection: course.sections.edges.length > 1,
      totalCards: 0,
      menuOpen: !this.props.isJoinLiveClass,
      updateSectionCells: true,
      badgePopupOpen: false,
      showRemainingLessonsPopup: false,
      remainingLessons: []
    };

    this.completeLessonsInOrderActive =
      !window.__unlockAllCards &&
      (cardNotAccessibleCoursePids.includes(course.pid) ||
        course.orderOfCompletion === CourseCompletionOrderEnum.inOrder);

    this.updateCardsArray(props);
    window.scormExitClicked = this.nextPressed;
    this.userIsTeacher = this.getIsUserTeacher(this.props);

    this.cardIdsInSync = [];
    this.setupCardsProgressSync();

    this.props.dataFetched && this.props.dataFetched('course', course.pid, course.name);

    this.state.showSection = course.sections.edges.length > 1;

    let totalCards = 0;
    for (let i = 0; i < course.sections.edges.length; i += 1) {
      totalCards += course.sections.edges[i].node.cards.edges.length;
    }
    this.state.totalCards = totalCards;

    this.isScormOnlyCourse =
      this.cardArray.length === 1 && this.cardArray[0].resource.type === 'scorm';

    if (this.props.windowWidth < 768 || this.isScormOnlyCourse) {
      this.state.menuOpen = false;
    }

    if (this.props.isJoinLiveClass) {
      const { store: liveClassStore } = this.props.liveClassModel;
      const completedCardIds = this.completedCards.map(card => card.pid);
      liveClassStore.progressSync.updateCompletedCards(completedCardIds, course.pid);

      disposeOnUnmount(this, [
        reaction(() => this.props.liveClassModel.store.progressSync.currentCardId, this.goToCard, {
          fireImmediately: true
        })
      ]);
    }
  }

  componentDidMount() {
    user.email() && window.hj && window.hj('trigger', 'learning_space');
    user.email() && window.hj && window.hj('tagRecording', [user.email()]);
    if (this.doNotRenderCourse) {
      return;
    }
    if (!isComponentMounted(this)) {
      return;
    }

    if (!this.props.previewCourse) {
      const { courseId, userId } = this.props.relay.variables;
      refetchCourseAndUpdateRelayStore(courseId, userId);
    }

    this.startTimer();
    this.context.closeSearch && this.context.closeSearch();
    window.onkeydown = this.keyPressed;
    $j('#CardWrapper video')
      .not('.ownSubmissionContainer video')
      .attr('controlsList', 'nodownload');
    const cardCellContainer = $j('.cardCellContainer');
    setTimeout(() => {
      cardCellContainer &&
        cardCellContainer.find('.currentCardCell').length > 0 &&
        cardCellContainer.parent('.collapsableChildContainer').animate({
          scrollTop:
            cardCellContainer.scrollTop() +
            cardCellContainer.find('.currentCardCell').offset().top -
            20 -
            cardCellContainer.offset().top
        });
    }, 200);
    // this.truncateContentDescription();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.relay.variables.cardId !== this.props.relay.variables.cardId) {
      clearTimeout(this.clearTempActiveTimer);
      this.clearTempActiveTimer = setTimeout(
        () => $j('.cardInfoContainer.tempActive').removeClass('tempActive'),
        1000
      );
      setTimeout(
        () =>
          $j('#CardWrapper video')
            .not('.ownSubmissionContainer video')
            .attr('controlsList', 'nodownload'),
        10
      );
    }

    const previousCompletedCardIds = this.completedCards.map(card => card.pid);

    this.updateCardsArray(this.props);

    if (prevProps.rootQ.pid !== this.props.rootQ.pid) {
      this.isScormOnlyCourse =
        this.cardArray.length === 1 && this.cardArray[0].resource.type === 'scorm';
      this.userIsTeacher = this.getIsUserTeacher(this.props);
      this.props.dataFetched &&
        this.props.dataFetched('course', this.props.rootQ.pid, this.props.rootQ.name);
    }

    if (prevProps.windowWidth > 768 && this.props.windowWidth < 768) {
      this.state.menuOpen = false;
    }

    this.completeLessonsInOrderActive =
      !window.__unlockAllCards &&
      (cardNotAccessibleCoursePids.includes(this.props.rootQ.pid) ||
        this.props.rootQ.orderOfCompletion === CourseCompletionOrderEnum.inOrder);

    // FOR BADGE POPUP!
    if (
      prevProps.rootQ.coursePerformance &&
      ((prevProps.rootQ.coursePerformance.completionStatus !== 'COMPLETE' &&
        this.props.rootQ.coursePerformance.completionStatus === 'COMPLETE') ||
        (prevProps.rootQ.coursePerformance.successStatus === 'NA' &&
          this.props.rootQ.coursePerformance.successStatus !== 'NA')) &&
      userContentStatus(
        this.props.rootQ,
        this.props.rootQ.coursePerformance,
        this.props.rootQ.assignInfo
      ) === 'COMPLETE' &&
      badgeExists(this.props.rootQ.badge)
    ) {
      this.state.badgePopupOpen = true;
    }

    const isJoinLiveClass = this.props.isJoinLiveClass;
    if (isJoinLiveClass) {
      const currentCompletedCardIds = this.completedCards.map(card => card.pid);
      if (!isEqual(previousCompletedCardIds.sort(), currentCompletedCardIds.sort())) {
        const { store: liveClassStore } = this.props.liveClassModel;
        const newCompletedCardIds = difference(currentCompletedCardIds, previousCompletedCardIds);
        liveClassStore.progressSync.updateCompletedCards(newCompletedCardIds, this.props.rootQ.pid);
      }
    }
  }

  componentWillUnmount() {
    this.stopTimer();
    window.onkeydown = null;
    $j('.leftNavRoot').animate(
      {
        left: '0px'
      },
      700
    );
  }

  timeoutReached = () => {
    if (this.props.previewCourse) return;
    const learnerCard =
      this.refs.learnerCard && this.refs.learnerCard.refs.component.refs.component;
    const cardTopView = learnerCard && learnerCard.refs.cardTopView.refs.component;
    cardTopView && cardTopView.addTime();
  };

  setupCardsProgressSync = async () => {
    const cardIdsInSync = await cardProgressSyncStatus(this.cardIdArray, {
      init: true,
      changeCallBack: this.cardSyncChange
    });
    if (cardIdsInSync.length > 0) {
      this.cardIdsInSync = cardIdsInSync;
      this.setState({});
    }
  };

  getIsUserTeacher = props => {
    const teachers = props.rootQ.teachers;
    const userId = props.relay.variables.userId;
    return teachers.some(teacher => teacher.pid === userId);
  };

  keyPressed = event => {
    const videoCardKeyPress = direction => {
      if ($j('#_videoCardVideoContainer_ video').length > 0) {
        return this.captureKeyPressForVideo(direction);
      }
      return false;
    };

    if (event.target.nodeName === 'INPUT' || event.target.nodeName === 'TEXTAREA') {
      return;
    }

    if (this.props.isJoinLiveClass) {
      return;
    }

    let isNewAssessmentPlayer = false;
    try {
      isNewAssessmentPlayer = this.refs.learnerCard.refs.component.refs.component.getAssignmentFullScreenStatus();
    } catch (err) {
      isNewAssessmentPlayer = false;
    }

    if (event.code === 'ArrowRight') {
      if (videoCardKeyPress('ArrowRight')) return;
      if (isNewAssessmentPlayer) return;
      this.nextPressed(LessonEventsFromEnum.Keyboard);
    } else if (event.code === 'ArrowLeft') {
      if (videoCardKeyPress('ArrowLeft')) return;
      if (isNewAssessmentPlayer) return;
      this.previousPressed(LessonEventsFromEnum.Keyboard);
    }
  };

  captureKeyPressForVideo(pressedKey) {
    const learnerCard = this.refs.learnerCard.refs.component.refs.component;

    if (
      learnerCard &&
      learnerCard.refs.videoCard &&
      learnerCard.refs.videoCard.refs.videoJsPlayerRef.videoJSPlayer &&
      learnerCard.refs.videoCard.refs.videoJsPlayerRef.videoJSPlayer.isFullscreen &&
      learnerCard.refs.videoCard.refs.videoJsPlayerRef.videoJSPlayer.isFullscreen()
      /* --FOR DISABLING ON PROD-- && process.env.MY_ENV !== 'production' */
    ) {
      return true;
    }

    if (
      !$j(document.activeElement).is('#_videoCardVideoContainer_ div') ||
      ($j('#_videoCardVideoContainer_ video')[0].ended && pressedKey === 'ArrowRight') ||
      ($j('#_videoCardVideoContainer_ video')[0].currentTime < 2 && pressedKey === 'ArrowLeft')
    ) {
      return false;
    }
    return true;
  }

  startTimer = () => {
    this.timer = setInterval(this.timeoutReached, addTimeSeconds);
  };

  stopTimer = () => {
    this.timer && clearInterval(this.timer);
  };

  goToCard = cardId => {
    this.changeCard(cardId);
    this.changeUrlForCard(cardId);
  };

  checkForRequiredStatus = (dataArray, cardIndex, requiredStatus) => {
    const currentCard = this.cardInfoArray[cardIndex];

    if (requiredStatus === 'PASS' && currentCard && currentCard.successStatus !== 'PASS') {
      dataArray.push(
        <div key={cardIndex} style={styles.cardLink} onClick={() => this.goToCard(currentCard.pid)}>
          {currentCard.globalPosition} {currentCard.cardName} {/* ({requiredStatus}) */}
        </div>
      );
    } else if (
      requiredStatus === 'COMPLETE' &&
      currentCard &&
      currentCard.completionStatus !== 'COMPLETE'
    ) {
      dataArray.push(
        <div key={cardIndex} style={styles.cardLink} onClick={() => this.goToCard(currentCard.pid)}>
          {currentCard.globalPosition} {currentCard.cardName} {/* ({requiredStatus}) */}
        </div>
      );
    }
    return dataArray;
  };

  checkCurrentCardLockStatus = cardIndex => {
    let cardLockData = this.props.rootQ.cardLockData;
    if (!cardLockData) return false;
    try {
      cardLockData = JSON.parse(cardLockData);
    } catch (e) {
      global.showErrorPopup && global.showErrorPopup();
      console.log('Error parsing card-l-Data', e);
      window.bugsnagClient && window.bugsnagClient.notify(e);
    }
    let dataArray = [];
    if (cardLockData[cardIndex]) {
      const cardData = cardLockData[cardIndex];
      Object.keys(cardData).forEach(key => {
        if (cardData.hasOwnProperty(key)) {
          dataArray = this.checkForRequiredStatus(dataArray, key, cardData[key]);
        }
      });
      return dataArray;
    }
    return false;
  };

  checkForNavigationButton = (direction, cardPid) => {
    if (direction === 'next') {
      if (findIndex(this.cardArray, { pid: cardPid }) === this.cardArray.length - 1) {
        return false;
      }
      return true;
    }
    if (direction === 'prev') {
      if (findIndex(this.cardArray, { pid: cardPid }) === 0) {
        return false;
      }
      return true;
    }
    return false;
  };

  getCurrentCard() {
    const sections = this.props.rootQ.sections.edges;
    let cardPosition = 0;
    // console.log('this.cardInfoArray', this.cardInfoArray);
    for (let sectionIndex = 0; sectionIndex < sections.length; sectionIndex += 1) {
      const cards = sections[sectionIndex].node.cards.edges;
      for (let cardIndex = 0; cardIndex < cards.length; cardIndex += 1) {
        const card = cards[cardIndex].node;
        // console.log('lockedStatus:: ', lockedStatus);
        cardPosition += 1;
        this.state.currentCard = card;
        if (card.pid === this.state.currentCardPid) {
          const showNext =
            !this.props.isJoinLiveClass && this.checkForNavigationButton('next', card.pid);

          const positionObj = {
            currentCard: cardPosition,
            totalCards: this.state.totalCards
          };
          const isAccessible =
            (this.props.rootQ.coursePerformance &&
              this.props.rootQ.coursePerformance.completionStatus === 'COMPLETE') ||
            !this.completeLessonsInOrderActive ||
            !checkIfCardLocked(this.cardInfoArray, card.pid) ||
            this.props.previewCourse;
          const lockedStatus =
            !this.userIsTeacher &&
            !this.props.previewCourse &&
            !window.__unlockAllCards &&
            this.checkCurrentCardLockStatus(cardPosition - 1);
          return (
            <LearnerCard
              ref="learnerCard"
              rootQ={card}
              cardArray={this.cardArray}
              cardArrayCurrentCardIndex={this.currentCardIndex}
              previousCard={cards[cardIndex - 1] ? cards[cardIndex - 1].node : null}
              userId={this.props.relay.variables.userId}
              previousPressed={this.previousPressed}
              nextPressed={this.nextPressed}
              showNext={showNext}
              positionObj={positionObj}
              userObj={this.props.rootQ.user}
              cardListMenuBtn={this.cardListMenuBtn}
              course={this.props.rootQ}
              lockedStatus={lockedStatus}
              previewCourse={this.props.previewCourse}
              pathInfo={this.props.pathInfo}
              menuOpen={this.state.menuOpen}
              backToCourse={this.backToCourse}
              isAccessible={isAccessible}
              history={this.props.history}
              isScormOnlyCourse={this.isScormOnlyCourse}
              isJoinLiveClass={this.props.isJoinLiveClass}
            />
          );
        }
      }
    }

    return null;
  }

  badgePopupOpen = open => {
    this.setState({
      badgePopupOpen: open
    });
  };

  cardSyncChange = currentlyInSyncCardIds => {
    if (!isEqual(this.cardIdsInSync.sort(), currentlyInSyncCardIds.sort())) {
      this.cardIdsInSync = currentlyInSyncCardIds;
      this.setState({});
    }
  };

  changeCard = cardPid => {
    const learnerCard =
      this.refs &&
      this.refs.learnerCard &&
      this.refs.learnerCard.refs.component &&
      this.refs.learnerCard.refs.component.refs.component;
    const cardTopView = learnerCard && learnerCard.refs.cardTopView.refs.component;
    cardTopView && cardTopView.checkTicker();

    if (
      (!this.props.rootQ.coursePerformance ||
        this.props.rootQ.coursePerformance.completionStatus !== 'COMPLETE') &&
      !this.props.previewCourse &&
      (this.completeLessonsInOrderActive && checkIfCardLocked(this.cardInfoArray, cardPid))
    ) {
      return false;
    }
    if (this.state.currentCardPid !== cardPid) {
      this.state.updateSectionCells = false;
      clearTimeout(this.sectionUpdateTimeout);
      this.sectionUpdateTimeout = setTimeout(() => {
        this.setState({ updateSectionCells: true }, () => {
          const cardCellContainer = $j('.cardCellContainer');

          const isCardOutOfView =
            cardCellContainer &&
            cardCellContainer.find('.currentCardCell').length > 0 &&
            (cardCellContainer.find('.currentCardCell').offset().top +
              cardCellContainer.find('.currentCardCell').height() >=
              $j(window).height() ||
              cardCellContainer.find('.currentCardCell').offset().top <
                $j(window).scrollTop() + 170);
          const currentCellTop =
            cardCellContainer.find('.currentCardCell') &&
            cardCellContainer.find('.currentCardCell').offset() &&
            cardCellContainer.find('.currentCardCell').offset().top;
          setTimeout(() => {
            isCardOutOfView &&
              cardCellContainer
                .parent('.collapsableChildContainer')
                .stop(true, true)
                .animate({
                  scrollTop:
                    cardCellContainer.scrollTop() +
                    currentCellTop -
                    20 -
                    cardCellContainer.offset().top
                });
          }, 100);
        });
      }, 300);
      const { store: liveClassStore } = this.props.liveClassModel;
      const { isTeacher, isRoomConnected } = liveClassStore;
      if (isTeacher && isRoomConnected) {
        liveClassStore.progressSync.updateCurrentCardId(cardPid);
      }
      this.setState({
        currentCardPid: cardPid
      });
      clearTimeout(this.keyEventTimeout);
      this.keyEventTimeout = setTimeout(() => {
        window.onkeydown = null;
        window.onkeydown = this.keyPressed;
      }, 50);
    }
  };

  updateCardsArray = props => {
    this.cardInfoArray = [];
    this.cardArray = [];
    this.cardIdArray = [];
    this.completedCards = [];

    let counter = 0;
    const sections = props.rootQ.sections.edges;
    for (let sectionIndex = 0; sectionIndex < sections.length; sectionIndex += 1) {
      const cards = sections[sectionIndex].node.cards.edges;
      for (let cardIndex = 0; cardIndex < cards.length; cardIndex += 1) {
        const card = cards[cardIndex].node;
        if (card.pid === this.state.currentCardPid) {
          this.currentCardIndex = counter;
        }
        props.dataFetched && props.dataFetched('card', card.pid, card.name);
        this.cardArray.push(card);
        if (card.performance && card.performance.completionStatus === 'COMPLETE') {
          this.completedCards.push(card);
        }
        this.cardInfoArray.push({
          pid: card.pid,
          id: card.id,
          cardName: card.name,
          cardId: card.pid,
          type: card.type,
          globalPosition: card.globalPosition,
          cardPerformanceId:
            !card.performance || card.performance === null ? null : card.performance.id,
          isGradable: card.isGradable,
          completionType: card.completionType,
          complete:
            !card.performance || card.performance === null
              ? null
              : card.performance.completionStatus === 'COMPLETE',
          completionStatus:
            !card.performance || card.performance === null
              ? null
              : card.performance.completionStatus,
          successStatus:
            !card.performance || card.performance === null ? null : card.performance.successStatus,
          isAccessible: false,
          questionAnswers: card.questionAnswers
        });
        this.cardIdArray.push(card.pid.toString());
        counter += 1;
      }
    }
    this.cardInfoArray.forEach(cardFromArray => {
      cardFromArray.isAccessible =
        !this.completeLessonsInOrderActive ||
        !checkIfCardLocked(this.cardInfoArray, cardFromArray.pid);
    });
  };

  cardListMenuBtn = () => {
    const open = !this.state.menuOpen;
    window.analytics &&
      window.analytics.track('LEARNING_INDEX_OPEN_CLOSE', {
        url: window.location.href,
        opening: open
      });
    this.setState({ menuOpen: open });
    if (!open) {
      $j('.leftNavRoot').animate(
        {
          left: '-70px'
        },
        700
      );
      $j('#wrapper').css('padding-left', '0px');
      $j('.bottomBar').css('left', '0px');
      $j('.sideView').css({
        'padding-left': '0px',
        'margin-left': '-10px'
      });
    } else {
      $j('.leftNavRoot').animate(
        {
          left: '0px'
        },
        700
      );
      // $j("#wrapper").css('padding-left','60px');
      // $j(".bottomBar").css('left','60px');
      $j('.sideView').css({
        // 'padding-left': '60px',
        'margin-left': '0px'
      });
    }
    return open;
  };

  remainingLessonsPopup = (show, lessons) => {
    this.setState({
      showRemainingLessonsPopup: show,
      remainingLessons: show ? lessons : this.state.remainingLessons
    });
  };

  backToCourse = bypass => {
    const remainingLessonsInfo = getRemainingLessonsInfo(this.cardArray);
    const remaining20 =
      remainingLessonsInfo.length > 0 &&
      (remainingLessonsInfo.length * 100) / this.cardArray.length <= 20;
    const scaledPM80 = this.props.rootQ.coursePerformance.scaledProgressMeasure >= 0.8;

    if (
      bypass !== true &&
      (remaining20 || scaledPM80) &&
      this.props.rootQ.coursePerformance.completionStatus !== 'COMPLETE'
    ) {
      this.remainingLessonsPopup(true, remainingLessonsInfo);
      return;
    }
    if (window.location.href.includes('/join')) {
      window.location.href = '/#/learner';
    } else if (
      window.location.href.indexOf('home') > -1 &&
      window.location.href.indexOf('/path') > -1 &&
      this.props.match.params.pathId
    ) {
      window.location.href = '/#/learner/home/paths/' + this.props.match.params.pathId;
    } else if (window.location.href.indexOf('home') > -1) {
      window.location.href = '/#/learner/home';
    } else if (window.location.href.indexOf('/path') > -1 && this.props.match.params.pathId) {
      window.location.href = '/#/learner/courses/paths/' + this.props.match.params.pathId;
    } else if (
      window.location.href.indexOf('/path') < 0 &&
      window.location.href.indexOf('home') < 0 &&
      window.location.href.indexOf('courses') > -1
    ) {
      window.location.href = '/#/learner/courses';
    } else {
      window.location.href = '/#/learner/home';
    }
  };

  countCards = cardArray => {
    if (this.props.rootQ.assignInfo === null) return 0;
    let count = 0;
    const completedCards = cardArray.filter(
      card => card.performance && card.performance.completionStatus === 'COMPLETE'
    );
    const isOptional = card => card.completionType === CardCompletionTypeEnum.optional;
    const optionalCompletedCards = completedCards.filter(isOptional).length;
    count = completedCards.length - optionalCompletedCards;
    return count;
  };

  renderTeachButton = ({ model }) => {
    const isLiveClassEnabled =
      window.__getFeatureFlagFunc && window.__getFeatureFlagFunc('live-class');
    if (!isLiveClassEnabled) {
      return null;
    }

    const { name, pid } = this.props.rootQ;

    if (this.props.isJoinLiveClass) {
      return null;
    }

    const { room } = model.store;
    const { roomStatus } = room;
    const { createClass, completeClass } = model.actions;

    let buttonTitle = '';
    let buttonIcon = null;
    let buttonDisabled = false;
    let handleClick = null;
    switch (roomStatus) {
      case RoomStatus.Connected: {
        buttonTitle = 'End Session';
        buttonIcon = { type: 'logout', style: { marginRight: '6px' } };
        handleClick = completeClass;
        break;
      }
      case RoomStatus.Connecting: {
        buttonTitle = 'Connecting';
        buttonIcon = <ActivityIndicator style={{ marginRight: '6px' }} />;
        buttonDisabled = true;
        handleClick = null;
        break;
      }
      case RoomStatus.NotCreated: {
        buttonTitle = 'Teach';
        buttonIcon = { type: 'desktop', style: { marginRight: '6px' } };
        handleClick = () =>
          createClass({
            contentId: pid,
            contentName: name,
            currentCardId: this.state.currentCardPid
          });
        break;
      }
      default:
        break;
    }

    return (
      <LearnerAccentButton
        className={s.teachButton}
        text={buttonTitle}
        icon={buttonIcon}
        disabled={buttonDisabled}
        onClick={handleClick}
      />
    );
  };

  renderViewCertificateAndBadge = () => {
    const { coursePerformance, certificateEnabled } = this.props.rootQ;
    const isCompleted = coursePerformance && coursePerformance.completionStatus === 'COMPLETE';
    const certificates = coursePerformance && coursePerformance.state.certificates;
    const attachedCertificates = certificates && certificates[0];
    const certificateName = this.props.rootQ.name;
    const badgeEnabled = badgeExists(this.props.rootQ.badge);
    const isMobile = this.props.windowWidth < 768;
    if ((isCompleted && !attachedCertificates) || !certificateEnabled) {
      if (!badgeEnabled) {
        return null;
      }
    }

    if (isCompleted && (attachedCertificates || badgeEnabled)) {
      return (
        <div style={styles.width100}>
          {attachedCertificates && (
            <ViewCertificate
              type="ButtonView"
              certificateData={{
                ...certificates[0],
                title: certificateName,
                activityType: 'course'
              }}
            />
          )}
          {badgeEnabled && (
            <ViewBadge
              type="ButtonView"
              badgeData={{
                ...parseBadge(this.props.rootQ.badge),
                contentId: this.props.rootQ.pid,
                userId: this.props.relay.variables.userId
              }}
              isMobile={isMobile}
            />
          )}
        </div>
      );
    }

    return (
      <div className="viewCertificateIcon">
        <IconComponent type="badge" scale={0.6} className="icon" />
      </div>
    );
  };

  renderEnrollAndProgress = () => {
    const actualCardsWithoutOptional = this.cardArray.filter(
      card => card.completionType !== CardCompletionTypeEnum.optional
    ).length;
    const actualCardsCompleted = this.countCards(this.cardArray);
    const { coursePerformance } = this.props.rootQ;
    const isMobile = this.props.windowWidth < 768;
    const progressPercent = (actualCardsCompleted * 100) / actualCardsWithoutOptional;
    const isCompleted = coursePerformance && coursePerformance.completionStatus === 'COMPLETE';
    const certificates = coursePerformance && coursePerformance.state.certificates;
    const attachedCertificates = certificates && certificates[0];
    return (
      <div style={styles.progressAndEnrollWrapper}>
        <div style={styles.progressWrapper}>
          {((isCompleted && !attachedCertificates) || !isCompleted) && (
            <div style={styles.progressContainer}>
              <div style={styles.progressBar}>
                <div className={s.progressBarFill(progressPercent)} />
              </div>
              {this.renderViewCertificateAndBadge()}
            </div>
          )}
          <span style={styles.progressText}>
            {`${actualCardsCompleted}/${actualCardsWithoutOptional} lessons completed`}
            {isMobile ? (
              <span className={s.mobileTeachBtn}>
                <LiveClassConsumer>{this.renderTeachButton}</LiveClassConsumer>
              </span>
            ) : null}
          </span>
        </div>
      </div>
    );
  };

  renderBackContent = windowLocation => {
    if (windowLocation.indexOf('/paths') > -1) {
      return 'Back to Path';
    }
    if (windowLocation.indexOf('home') > -1) {
      return 'Back to Home';
    }
    if (windowLocation.indexOf('learner/courses') > -1) {
      return 'Back to Library';
    }
    if (windowLocation.indexOf('learner/browse') > -1) {
      return 'Back to Browse';
    }
    return 'Back to Home';
  };

  changeUrlForCard = cardId => {
    if (this.props.previewCourse) return;
    const [prefixRoute] = window.location.hash.split('/card');
    window.history.replaceState(null, null, `/${prefixRoute}/card?cardId=${cardId}`);
  };

  previousPressed = eventFrom => {
    if (
      (!this.props.rootQ.coursePerformance ||
        this.props.rootQ.coursePerformance.completionStatus !== 'COMPLETE') &&
      !this.props.previewCourse &&
      (this.completeLessonsInOrderActive &&
        checkIfCardLocked(this.cardInfoArray, this.cardInfoArray[this.currentCardIndex].pid))
    ) {
      return;
    }
    const previousCardObject = this.cardInfoArray[this.currentCardIndex - 1];
    if (previousCardObject !== undefined) {
      const eventName = 'PREV_LESSON_PRESSED';
      let eventSource = '';

      if (eventFrom === LessonEventsFromEnum.UI) {
        eventSource = 'UI';
      } else if (eventFrom === LessonEventsFromEnum.Keyboard) {
        eventSource = 'Keyboard';
      } else if (eventFrom === LessonEventsFromEnum.System) {
        eventSource = 'System';
      }
      window.analytics &&
        window.analytics.track(eventName, {
          card_index: previousCardObject.globalPosition,
          card_type: previousCardObject.type,
          card_name: previousCardObject.cardName,
          card_id: previousCardObject.cardId,
          eventFrom: eventSource
        });
      this.stopTimer();
      this.currentCardIndex -= 1;

      this.goToCard(previousCardObject.cardId);

      this.startTimer();
    }
  };

  nextPressed = eventFrom => {
    if (
      (!this.props.rootQ.coursePerformance ||
        this.props.rootQ.coursePerformance.completionStatus !== 'COMPLETE') &&
      !this.props.previewCourse &&
      (this.completeLessonsInOrderActive &&
        checkIfCardLocked(this.cardInfoArray, this.cardInfoArray[this.currentCardIndex].pid))
    ) {
      return;
    }
    const nextCardObject = this.cardInfoArray[this.currentCardIndex + 1];
    if (nextCardObject !== undefined && nextCardObject.isAccessible) {
      const eventName = 'NEXT_LESSON_PRESSED';
      let eventSource = '';

      if (eventFrom === LessonEventsFromEnum.UI) {
        eventSource = 'UI';
      } else if (eventFrom === LessonEventsFromEnum.Keyboard) {
        eventSource = 'Keyboard';
      } else if (eventFrom === LessonEventsFromEnum.System) {
        eventSource = 'System';
      }
      window.analytics &&
        window.analytics.track(eventName, {
          card_index: nextCardObject.globalPosition,
          card_type: nextCardObject.type,
          card_name: nextCardObject.cardName,
          card_id: nextCardObject.cardId,
          eventFrom: eventSource
        });
      this.stopTimer();
      this.currentCardIndex += 1;

      this.goToCard(nextCardObject.cardId);

      this.startTimer();
    }
  };

  renderCards = () => {
    this.sectionRefs = [];
    this.activeSectionCell = -1;
    return this.props.rootQ.sections.edges.map((edge, sectionIndex) => {
      edge.node.cards.edges.map((card, i) => {
        if (!this.currentCardIndex) {
          this.currentCardIndex = 0;
        }
        if (this.cardArray[this.currentCardIndex].pid === card.node.pid) {
          this.activeSectionCell = sectionIndex;
        }
      });

      return (
        <SectionCell
          key={edge.node.pid}
          rootQ={edge.node}
          cardTapped={this.cardTapped}
          userId={this.props.relay.variables.userId}
          showSection={this.state.showSection}
          cardArray={this.cardArray}
          sectionIndex={sectionIndex}
          currentCardIndex={this.currentCardIndex}
          currentSection={this.activeSectionCell === sectionIndex}
          ref={ref => {
            this.sectionRefs.push({ ref, sectionIndex });
          }}
          shouldUpdate={this.state.updateSectionCells}
          courseEnrolled={!!this.props.rootQ.coursePerformance}
          lastSection={sectionIndex === this.props.rootQ.sections.edges.length - 1}
          cardInfoArray={this.cardInfoArray}
          cardIdsInSync={this.cardIdsInSync}
        />
      );
    });
  };

  renderLessonsIncompletePopup = (showPopup, backToText) => (
    <RemainingLessonsPopup
      lessons={this.state.remainingLessons}
      hidePopup={() => this.remainingLessonsPopup(false)}
      showPopup={showPopup}
      onLessonClick={this.cardTapped}
      onBackToHome={() => this.backToCourse(true)}
      backToText={backToText}
    />
  );

  makeCardTempActive = target => {
    $j('.cardInfoContainer.active').removeClass('active');
    if ($j(target).hasClass('cardInfoContainer')) {
      $j(target).addClass('tempActive');
    } else {
      $j(target)
        .closest('.cardInfoContainer')
        .addClass('tempActive');
    }
  };

  cardTapped = (cardId, e) => {
    window.analytics &&
      window.analytics.track('LEARNING_INDEX_LESSON_CLICKED', {
        cardId,
        url: window.location.href
      });
    const position = this.cardIdArray.indexOf(cardId.toString());
    if (position > -1) {
      if (
        (!this.props.rootQ.coursePerformance ||
          this.props.rootQ.coursePerformance.completionStatus !== 'COMPLETE') &&
        !this.props.previewCourse &&
        (this.completeLessonsInOrderActive && checkIfCardLocked(this.cardInfoArray, cardId))
      ) {
        return;
      }
      this.stopTimer();
      this.goToCard(cardId);
      this.makeCardTempActive(e.target);

      this.currentCardIndex = position;
      this.startTimer();
    }
  };

  renderMobileNavClose = windowWidth => {
    if (windowWidth < 768) {
      return (
        <div style={styles.mobileCloseBtnContainer} onClick={this.cardListMenuBtn}>
          <Icon icon="close" size="15px" viewBox="4 4 16 16" fill="var(--color-black3)" />
        </div>
      );
    }
    return null;
  };

  addToAnalytics = () => {
    window.analytics &&
      window.analytics.track('COURSE_DETAILS_CLICKED', {
        courseId:
          this.props.relay && this.props.relay.variables && this.props.relay.variables.courseId,
        url: window.location.href
      });
  };

  render() {
    if (this.doNotRenderCourse) {
      return null;
    }
    // console.log('this.cardIdsInSync:: ', this.cardIdsInSync);
    const card = this.getCurrentCard();
    if (!card) {
      return null;
    }

    const isMobile = this.props.windowWidth < 768;
    const isPreview = this.props.previewCourse;
    const theme = this.props.theme;
    const isBlock = this.state.currentCard.resource.type === 'blocks';

    return (
      <div style={styles.sideWrapper} className="learnerIndexWrapper">
        <div className={c(s.main, { [s.mainBlock]: isBlock })}>{card}</div>
        {this.isScormOnlyCourse &&
          this.props.rootQ.coursePerformance &&
          this.props.rootQ.coursePerformance.completionStatus === 'COMPLETE' && (
            <CourseCompleteSnackBar />
          )}
        <div
          className={'sideViewBlocker' + (this.state.menuOpen && isMobile ? ' show' : '')}
          role="presentation"
          onClick={this.cardListMenuBtn}
        />
        <div className={c(s.sideView(this.state.menuOpen), 'sideView')} ref="sideView">
          <div style={styles.container}>
            <div style={styles.backToSection}>
              {this.renderMobileNavClose(this.props.windowWidth)}
              <div style={styles.width100}>
                {!isPreview && (
                  <div>
                    <div className={s.backContainer}>
                      <LearnerAccentButton
                        className={s.backButton}
                        text={this.renderBackContent(window.location.href)}
                        icon={{ type: 'angle-left' }}
                        onClick={this.backToCourse}
                      />
                      <LiveClassConsumer>{this.renderTeachButton}</LiveClassConsumer>
                    </div>
                  </div>
                )}
                <div className={s.courseText}>
                  <Dotdotdot clamp={1} className="dotdotdotWrapper">
                    <span className={s.courseName(theme)} title={this.props.rootQ.name}>
                      {this.props.rootQ.name}
                    </span>
                  </Dotdotdot>
                </div>
                <div style={styles.width100}>{this.renderEnrollAndProgress()}</div>
                {this.props.rootQ.coursePerformance &&
                  this.props.rootQ.coursePerformance.completionStatus === 'COMPLETE' &&
                  this.renderViewCertificateAndBadge()}
              </div>
            </div>
          </div>
          <CollapsableGroup startIndex={2}>
            <CollapsableItem
              className="collapsableBorderBottom"
              title="COURSE DETAILS"
              onTitleClick={this.addToAnalytics}
            >
              <CourseDetails rootQ={this.props.rootQ} />
            </CollapsableItem>
            <CollapsableItem className="collapsableBorderBottom" title="TABLE OF CONTENTS">
              <div className="cardCellContainer">{this.renderCards.bind(this)()}</div>
            </CollapsableItem>
          </CollapsableGroup>
        </div>
        {this.state.loader ? <OverlayLoader /> : null}
        {this.renderLessonsIncompletePopup(
          this.state.showRemainingLessonsPopup,
          this.renderBackContent(window.location.href)
        )}
        <Style rules={styles.classBased} />
      </div>
    );
  }
}

const styles = {
  classBased: {
    '.CircularProgressbarSVG': {
      display: 'block',
      height: '14px',
      width: '14px',
      marginRight: '0px',
      transition: 'height 0.2s ease, width 0.2s ease'
    },
    '.CircularProgressbarSVG.active': { height: '24px', width: '24px' },
    '.CircularProgressbarSVG .CircularProgressbar-trail': { stroke: '#606c7a' },
    '.CircularProgressbarSVG .CircularProgressbar-text': { display: 'none' },
    '.CircularProgressbarSVG .CircularProgressbar-path': {
      stroke: '#00cd8a',
      strokeLinecap: 'round',
      transition: 'stroke-dashoffset 0.5s ease 0s'
    },
    '.CircularProgressbarSVG.isInSync .CircularProgressbar-path': { stroke: 'red' },
    '.sectionInfoContainer': {
      padding: '14px 19px 14px 16px',
      cursor: 'pointer',
      position: 'relative',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      background: 'var(--color-black1)'
    },
    '.sectionInfoContainer .sectionLabel': {
      color: 'var(--color-black3)',
      fontSize: '16px',
      lineHeight: '1.2em',
      flexDirection: 'row',
      display: 'flex'
    },
    '.sectionInfoContainer.active .sectionLabel': {
      fontWeight: '500',
      color: 'var(--color-grey1)'
    },
    '.sectionInfoContainer.active svg': {
      fill: 'var(--color-grey1) !important'
    },
    '.sectionInfoContainer:hover .sectionLabel': {
      color: 'var(--color-grey2)'
    },
    '.sectionInfoContainer:hover .sectionIcon': {
      fill: 'var(--color-accent-hover) !important'
    },
    '.sectionInfoContainer:active .sectionIcon': {
      fill: 'var(--color-accent-clicked) !important'
    },
    '.sectionIconContainer': {
      marginRight: '11px'
    },
    '.sectionCardsContainer': {
      backgroundColor: themeConfig.staticColor.learnerIndexBg
    },
    '.cardCellContainer .cardInfoContainer': {
      display: 'flex',
      padding: '11px 19px 11px 20px',
      flexDirection: 'row',
      float: 'left',
      alignItems: 'center',
      margin: '0',
      color: 'var(--color-black3)',
      minHeight: '45px'
    },
    '.cardCellContainer .cardInfoContainer.active, .cardCellContainer .cardInfoContainer.tempActive': {
      backgroundColor: themeConfig.staticColor.learnerIndexActiveBg
    },
    '.cardCellContainer .cardInfoContainer:not(.isNotAccessible):hover': {
      color: 'var(--color-grey1)'
    },
    '.cardCellContainer .cardInfoContainer:not(.isNotAccessible):hover .cardIcon': {
      fill: 'var(--color-grey1) !important'
    },
    '.cardCellContainer .cardInfoContainer:not(.isNotAccessible).active, .cardCellContainer .cardInfoContainer:not(.isNotAccessible).tempActive, .cardCellContainer .cardInfoContainer:not(.isNotAccessible):active': {
      color: '#ffffff'
    },
    '.cardCellContainer .cardInfoContainer:not(.isNotAccessible):active .cardIcon, .cardCellContainer .cardInfoContainer:not(.isNotAccessible).active  .cardIcon, .cardCellContainer .cardInfoContainer:not(.isNotAccessible).tempActive .cardIcon': {
      fill: '#fff !important'
    },
    '.cardStatusIcon': {
      height: '14px',
      width: '14px',
      marginRight: '0px',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'height 0.2s ease, width 0.2s ease, margin 0.2s ease'
    },
    '.cardStatusIcon.active': {
      height: '23px',
      width: '23px',
      marginRight: '-4px'
    },
    '.inProgressIconWrapper': {
      position: 'relative',
      transition: 'margin 0.2s ease, height 0.2s ease, width 0.2s ease',
      height: '24px',
      width: '24px',
      marginRight: '-4px',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center'
    },
    '.inProgressIconWrapper.active': {},
    '.inProgressIconContainer': {
      position: 'absolute',
      top: '25%',
      left: '22%'
    },
    '.inProgressIconContainer.active': {
      marginRight: ''
    },
    '.sideViewBlocker': {
      position: 'fixed',
      top: '-100px',
      left: '-100px',
      opacity: '0.0001',
      background: 'rgba(0,0,0,0.3)',
      transition: 'opacity 0.4s'
    },
    '.sideViewBlocker.show': {
      top: '0px',
      bottom: '0px',
      right: '0px',
      left: '0px',
      opacity: '1',
      zIndex: '20'
    },
    '.collapsableBorderBottom': {
      borderBottom: '1px solid var(--color-indexLine)'
    },
    '.viewCertificateIcon': {
      position: 'absolute',
      right: '-23px',
      top: '0px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '25px',
      height: '25px',
      borderRadius: '50px',
      cursor: 'auto',
      backgroundColor: '#38485e'
    },
    '.viewCertificateIcon svg': {
      fill: '#ffffff'
    }
  },
  main: {
    display: 'flex',
    flexDirection: 'column',
    flex: 4,
    position: 'relative'
  },
  open: {
    marginLeft: '320px'
  },
  sideWrapper: {
    position: 'relative',
    width: '100%'
  },
  progressAndEnrollWrapper: {
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  progressWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '252px',
    position: 'relative'
  },
  progressContainer: {
    width: '100%',
    float: 'left',
    display: 'flex',
    alignItems: 'center',
    height: '25px'
  },
  progressBar: {
    backgroundColor: '#39485e',
    width: '100%',
    border: 'none',
    height: '6px',
    borderRadius: '7px',
    overflow: 'hidden',
    position: 'relative',
    WebkitMaskImage:
      'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAA5JREFUeNpiYGBgAAgwAAAEAAGbA+oJAAAAAElFTkSuQmCC)'
  },
  progressText: {
    color: 'var(--color-black3)',
    fontSize: '14px',
    lineHeight: '16px',
    letterSpacing: '0.1px'
  },
  text: {
    fontSize: '12px',
    color: 'rgba(0,0,0,0.8)',
    marginLeft: '2px',
    float: 'left',
    fontWeight: '400'
  },
  content: {
    overflowY: 'auto',
    flexDirection: 'column',
    position: 'absolute',
    bottom: '0px',
    width: '320px',
    boxSizing: 'border-box'
  },
  contentTopSpacing: {
    top: '210px'
  },
  contentSection: {
    color: 'var(--color-black3)',
    padding: '25px 20px 12px',
    lineHeight: '18px',
    fontWeight: kBoldFont,
    fontSize: '13px',
    letterSpacing: '1px',
    textTransform: 'uppercase',
    borderBottom: '1px solid #303d4a'
  },
  width100: {
    width: '100%'
  },
  backToSection: {
    padding: '20px 20px 19px',
    borderBottom: '1px solid var(--color-indexLine)',
    letterSpacing: '-0.1px',
    fontSize: '14px',
    color: '#fff',
    lineHeight: '22px',
    display: 'flex',
    flexDirection: 'row',
    position: 'relative'
  },
  container: {
    flexShrink: 0
  },
  enrollDialogStyle: {
    width: 300,
    height: 200
  },
  icon: {
    float: 'left',
    marginRight: 5
  },
  border: {
    width: '100%',
    bottom: 0,
    borderBottom: 'solid 2px #182d3c'
  },
  backIconContainer: {
    minWidth: '8px',
    width: '8px',
    marginRight: '7px',
    display: 'flex'
  },
  cardLink: {
    color: '#4a90e2',
    letterSpacing: '0.2px',
    lineHeight: '25px',
    fontSize: '15px',
    fontWeight: '500',
    cursor: 'pointer',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  mobileCloseBtnContainer: {
    position: 'absolute',
    top: '16px',
    right: '15px',
    padding: '5px',
    cursor: 'pointer'
  }
};

export const LearnerViewCardsRC = Relay.createContainer(windowResize(LearnerViewCards), {
  initialVariables: {
    userId: null,
    courseId: null,
    resolveLocally: true
  },
  fragments: {
    rootQ: rootQuery
  }
});

const LearnerViewCardsContainer = props => {
  const userCourseRoute = new LearnerViewCardsRoute({
    courseId: props.match.params.courseId,
    userId: user.id() || '5e7de277beee070008721310', // Static id for creator end preview
    resolveLocally: true
  });
  return (
    <RelayQueryRendererLegacy
      extraComponentProps={props}
      Component={LearnerViewCardsRC}
      query={userCourseRoute}
    />
  );
};

export default LearnerViewCardsContainer;
